const slider = new Swiper('.hero-slider', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  centeredSlides: true,
  speed: 800,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
  },
  breakpoints: {
    992: {
      spaceBetween: 24,
    },
    1712: {
      centeredSlides: true,
    },
  },
});

const gameSlider = new Swiper('.game-slider', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  centeredSlides: true,
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  navigation: {
    nextEl: '.game-next',
    prevEl: '.game-prev',
    disabledClass: 'swiper-button-disabled',
  },
});

const playerSlider = new Swiper('.players-slider', {
  speed: 600,
  loop: true,
  slidesPerView: 1.55,
  centeredSlides: true,
  spaceBetween: 11,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  breakpoints: {
    768: {
      slidesPerView: 2.3,
    },
    992: {
      slidesPerView: 3.64,
      spaceBetween: 6,
    },
    1440: {
      slidesPerView: 4.2,
    },
  },
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
    disabledClass: 'swiper-button-disabled',
  },
});

const pickupSwiper = new Swiper('.pickup-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 24,
  navigation: {
    nextEl: '.pickup-next',
    prevEl: '.pickup-prev',
    disabledClass: 'swiper-button-disabled',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  watchOverflow: true,
});

document.querySelectorAll('.loading-text').forEach((el) => {
  const text = el.textContent;
  el.innerHTML = text
    .split('')
    .map((char, i) => {
      const safeChar = char === ' ' ? '&nbsp;' : char;
      return `<span style="animation-delay:${i * 0.1}s">${safeChar}</span>`;
    })
    .join('');
});
